module.exports = __webpack_public_path__ + "static/media/dashboard-icon-active (1).69e4f395.svg";